import { render, staticRenderFns } from "./ImportTransfer.vue?vue&type=template&id=a2d25652"
import script from "./ImportTransfer.vue?vue&type=script&lang=js"
export * from "./ImportTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports